// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FriendlyCaptchaController from "./friendly_captcha_controller.js"
application.register("friendly-captcha", FriendlyCaptchaController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)

import SwiperController from "./swiper_controller.js"
application.register("swiper", SwiperController)

import MegamenuCollapseController from "./megamenu_collapse_controller.js"
application.register("megamenu-collapse", MegamenuCollapseController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import LineClampController from "./line_clamp_controller.js"
application.register("line-clamp", LineClampController)

import ScrollToController from "./scroll_to_controller.js"
application.register("scroll-to", ScrollToController)

import GoogleMapController from "./google_map_controller.js"
application.register("google-map", GoogleMapController)

import RetreatFilterController from "./retreat_filter_controller.js"
application.register("retreat-filter", RetreatFilterController)
